<template>
    <el-container class="home-container">
      <!-- 头部区域 -->
    <el-header>
    <div>
     <span>MES运营平台</span>
   </div>
        <home-header/>
    </el-header>
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏区域 -->
     <home-left />
     <!-- 页面右侧主体区域 -->
     <home-main />
    </el-container>
    </el-container>
</template>
<script>

import { HomeHeader, HomeLeft, HomeMain } from './components'
export default {
  components: {
    HomeLeft,
    HomeHeader,
    HomeMain
  }
}
</script>
<style lang="less" scoped>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
.el-icon-arrow-down {
    font-size: 12px;
  }

.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #ffffff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}
.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}
.el-main {
  background-color: #EAEDF1;
}
.home-container {
  height: 100%;
}
.iconfont {
  margin-right: 10px;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;//使其变成可点击
}
</style>
